import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { resetPassword } from "../services/login";
import "../styles/login.css";

const ResetPasswordPage = () => {
    const [searchParams] = useSearchParams();
    const hashToken = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("token");
    const token = searchParams.get("token") || hashToken;
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            setMessage("Токен не знайдено в URL");
        }
    }, [token]);

    const handleSubmit = async () => {
        if (!password || !confirmPassword) {
            setMessage("Заповніть обидва поля");
            return;
        }
        if (password !== confirmPassword) {
            setMessage("Паролі не співпадають");
            return;
        }
        if (password.length < 6) {
            setMessage("Новий пароль має бути щонайменше 6 символів");
            return;
        }

        try {
            setLoading(true);
            const data = await resetPassword(token, password);
            setMessage(data.message || "Пароль успішно змінено");
            setTimeout(() => navigate("/"), 2000);
        } catch (error) {
            setMessage(error.message || "Помилка при зміні пароля");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <h2>Відновлення пароля</h2>
            {token ? (
                <>
                    <div className="form-group">
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Новий пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button
                                type="button"
                                className="toggle-password-btn"
                                onClick={() => setShowPassword((value) => !value)}
                                title={showPassword ? "Приховати пароль" : "Показати пароль"}
                                aria-label={showPassword ? "Приховати пароль" : "Показати пароль"}
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                        <div className="password-input-wrapper">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Підтвердження пароля"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button
                                type="button"
                                className="toggle-password-btn"
                                onClick={() => setShowConfirmPassword((value) => !value)}
                                title={showConfirmPassword ? "Приховати пароль" : "Показати пароль"}
                                aria-label={showConfirmPassword ? "Приховати пароль" : "Показати пароль"}
                            >
                                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>
                    <div className="button-group">
                        <button onClick={handleSubmit} disabled={loading}>
                            {loading ? "Зачекайте..." : "Змінити пароль"}
                        </button>
                    </div>
                </>
            ) : (
                <p>Токен відсутній або неправильний</p>
            )}
            {message && <p>{message}</p>}
        </div>
    );
};

export default ResetPasswordPage;